import React from "react";
import { CloseOutlined } from "@ant-design/icons";
import "./LotterySharePosterModal.scss";

function LotterySharePosterModal({
  posterPreview,
  subtitle = "好友扫码进入题库页，每日可为你增加 1 次抽奖机会\n若有1位同学经过你分享的海报购买题库Pro会员，您将于今天额外获得1次抽奖机会，n位同学购买将获得额外n次抽奖机会",
  onClose,
  onCopyLink,
  onDownload,
}) {
  return (
    <div className="lottery-share-poster-mask">
      <div className="lottery-share-poster-modal">
        <button
          type="button"
          className="lottery-share-poster-close"
          onClick={onClose}
        >
          <CloseOutlined />
        </button>
        <div className="lottery-share-poster-title">分享活动海报</div>
        <div className="lottery-share-poster-subtitle">{subtitle}</div>
        <div className="lottery-share-poster-preview">
          {posterPreview ? (
            <img
              className="lottery-share-poster-composed-image"
              src={posterPreview}
              alt="题库Pro会员分享海报"
            />
          ) : (
            <div className="lottery-share-poster-loading">海报生成中...</div>
          )}
        </div>
        <div className="lottery-share-poster-actions">
          <button
            type="button"
            className="lottery-share-poster-download"
            onClick={onDownload}
          >
            保存海报
          </button>
          <button
            type="button"
            className="lottery-share-poster-cancel"
            onClick={onCopyLink}
          >
            复制链接
          </button>
        </div>
      </div>
    </div>
  );
}

export default LotterySharePosterModal;
